<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;margin:0 10px;"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">播单管理详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <div class="listStep">
        <el-steps :active="active" align-center>
          <el-step
            v-for="(item, index) in titleList"
            :title="item.title"
            :key="index"
            @click.native="stepChange(index)"
          ></el-step>
        </el-steps>
      </div>
      <div style="margin: 20px 0">
        <el-divider></el-divider>
      </div>
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
          v-if="active == 0"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="播单名称" prop="name">
                <el-input v-model="data.name" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="是否发布" prop="publishStatus">
                <el-switch v-model="data.publishStatus"  
                  active-text="是"
                  inactive-text="否"
                  active-value="1"
                  inactive-value="0"></el-switch>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input
                  v-model="data.remark"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 10 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <ProgramManagerInfo
        v-if="active == 1"
        :ProgramList="TaskProgramList"
        @search="search"
        @nextStep="nextStep"
        @preStep="preStep"
        @onBack="onBack"
        :taskId="taskId"
      ></ProgramManagerInfo>
      <PlanInfo
        v-if="active == 2"
        :PlanList="TaskPlanList"
        @nextStep="nextStep"
        @preStep="preStep"
        @onBack="onBack"
        :taskId="taskId"
        @search="search"
      ></PlanInfo>
      <TerminalConfig
        v-if="active == 3"
        :TaskDeviceList="TaskDeviceList"
        @nextStep="nextStep"
        @preStep="preStep"
        @onBack="onBack"
        :taskId="taskId"
        @search="search"
      ></TerminalConfig>
      <el-footer style="text-align: center" v-if="active == 0">
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存,下一步</el-button
        >
        <el-button @click="onBack()">返回</el-button>
      </el-footer>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";  
import ZJApp from "../../../../../app";
import ProgramManagerInfo from "./ProgramManagerInfo.vue";
import PlanInfo from "./PlanInfo.vue";
import TerminalConfig from "./TerminalConfig.vue";
import { addBroadcast, BroadcastInfo, editBroadcast} from "@/api/src/broadcast";
export default {
  name: "BroadcastListInfo",
  controller: "UI",
  action: "BroadcastListInfo",
  components: {
    ProgramManagerInfo,
    PlanInfo,
    TerminalConfig,
  },
  data() {
    return {
      data: {
        publishStatus:1
        //  choiceDataList:[]
      },
      active: 0,
      ItemTypeArr: [
        { value: 1, label: "广播词" },
        { value: 2, label: "MP3" },
      ],
      IsEdit: false,
      rules: {
        name: [{ required: true, message: "请输入播单名称", trigger: "blur" }],
      },
      titleList: [
        {
          title: "播单概况",
        },
        {
          title: "节目管理",
        },
        {
          title: "播放计划",
        },
        {
          title: "终端配置",
        },
      ],
      taskId: "",
      TaskProgramList: [],
      TaskDeviceList: [],
      TaskPlanList: [],
    };
  },
  created: function() {
    if (this.$route.query.id) {
      this.taskId = this.$route.query.id;
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    search() {
      let InfoId = this.$route.query.id;
      if (InfoId) {
        BroadcastInfo({id:InfoId}).then(res=>{
          console.log("单个信息")
          console.log(res)
          if(res.code==200){
            this.data = res.data;
            this.TaskProgramList = res.data;

          }
        })
        // new MyApis.TaskApi()
        //   .GetItemById({ id: InfoId })
        //   .then((r) => {
        //     r = r.data.Data;
        //     console.log(r);
        //     this.data = r;
        //     this.data.IsPublished = this.data.IsPublished == 1;
        //     this.TaskDeviceList = this.data.TaskDeviceList;
        //     this.TaskPlanList = this.data.TaskPlanList;
        //     this.TaskProgramList = this.data.TaskProgramList;
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        //   });
      }
    },
    //返回按钮
    onBack() {
      // this.$router.go(-1); //返回上一层
      this.$router.push({
        path: "/plugin/broadcast/ui/BroadcastListView",
        // query: { id: row.id, type: "edit" },
      });
    },

    stepChange(current) {
      if (this.$route.query.type == "edit") {
        this.active = current;
      } else {
        this.$message({
          type: "warning",
          message: "请填写播单概况",
        });
      }
    },
    //下一步
    nextStep() {
      //this.active = step;
      if (this.active++ > 2) this.active = 0;
    },
    // 步骤条上一步
    preStep() {
      this.$route.query.type = "edit";
      this.$route.query.InfoId = this.taskId;
      if (this.active-- < 0) this.active = 0;
      this.search();
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      // if (this.$route.query.type == "edit") {
      //   uuid = this.$route.query.InfoId;
      // } 
      // else {
      //   uuid = ZJApp.ZJUtils.uuid();
      // }
      // // this.data.IsPublished = this.data.IsPublished ? 1 : 0;
      if (this.$route.query.type == "edit") {
        //编辑
        editBroadcast(this.data).then(res=>{
          console.log("新增播单结果")
          console.log(res)
          if(res.code==200){
            this.$message({
              type: "success",
              message: "保存成功！!",
            });
            this.nextStep();
          }else{
            this.errmsg("保存失败！");
          }
        })
        // this.data.ModifyTime = new Date();
        // this.data.Modifier = ZJApp.ZJUser.current.UserName;
        // new MyApis.TaskApi()
        //   .UpdateItem(this.data)
        //   .then((r) => {
        //     r = r.data.Data;
        //     this.$message({
        //       type: "success",
        //       message: r ? "保存成功！" : "保存失败！",
        //     });
        //     this.logInfo.ActionName = "播单信息修改";
        //     this.logInfo.LogMessage = r
        //       ? "播单信息修改成功"
        //       : "播单信息修改失败";
        //     this.logInfo.ModuleName = "广播系统";
        //     this.logInfo.PageName = "播单管理详情";
        //     this.addOperationLog();
        //     this.nextStep();
        //     //this.$router.go(-1); //返回上一层
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        //   });
      } else {
        // 增加
        // let formObj = {
        //   Creater: ZJApp.ZJUser.current.UserName,
        //   CreateTime: new Date(),
        //   Modifier: ZJApp.ZJUser.current.UserName,
        //   ModifyTime: new Date(),
        //   TaskId: uuid,
        //   Validity: 1, //新增编辑是1，删除是0
        // };
        // let formAll = Object.assign(formObj, this.data);
        // formAll = JSON.stringify(formAll);
        // formAll = JSON.parse(formAll);
        console.log("this.data")
        console.log(this.data)
        // if(this.data.publishStatus=="true"){
        //   this.data.publishStatus = 1;
        // }else{
        //   this.data.publishStatus = 0;
        // }
        addBroadcast(this.data).then(res=>{
          console.log("新增播单结果")
          console.log(res)
          if(res.code==200){
            this.$message({
              type: "success",
              message: "保存成功!",
            });
            this.taskId = res.data;
            this.nextStep();
          }else{
            this.errmsg("服务异常，请联系管理员！");
          }
        })
        // new MyApis.TaskApi()
        //   .AddItem(formAll)
        //   .then((r) => {
        //     r = r.data.Data;
        //     this.$message({
        //       type: "success",
        //       message: r ? "保存成功！" : "保存失败！",
        //     });
        //     this.taskId = uuid;
        //     this.logInfo.ActionName = "播单信息添加";
        //     this.logInfo.LogMessage = r
        //       ? "播单信息添加成功"
        //       : "播单信息添加失败";
        //     this.logInfo.ModuleName = "广播系统";
        //     this.logInfo.PageName = "播单管理详情";
        //     this.addOperationLog();
        //     this.nextStep();
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        //   });
      }
    },
  },
};
</script>
<style lang="scss">
.listStep {
  .el-step__icon {
    background: #3d9fff;
  }
}
</style>
